import dayjs from 'dayjs'
import { useCallback, useState } from 'react'
import { GetClientListPayload, IClientSetup } from 'src/app/shared/models/clientSetup.model'
import { getClientList } from 'src/app/shared/services/ClientSetupService'
import { formatCutoffTime } from './utils'

export const useClientSetup = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [clientList, setClientList] = useState<Array<IClientSetup>>([])
  const [totalRecords, setTotalRecords] = useState(0)
  const [isActive, setIsActive] = useState<boolean>(true)

  const formatClientSetupData = (data: any) => {
    return data?.map((item: any) => ({
      ...item,
      defaultAchExceptionCutoffTime: formatCutoffTime(item?.defaultAchExceptionCutoffTime),
      defaultCheckExceptionCutoffTime: formatCutoffTime(item?.defaultCheckExceptionCutoffTime),
      createdAt: item?.createdAt ? dayjs(item?.createdAt).format('MM/DD/YYYY') : '',
      archivedDate: item?.archivedDate ? dayjs(item?.archivedDate).format('MM/DD/YYYY') : '',
    }))
  }

  const getClientListData = useCallback(
    async (params: GetClientListPayload) => {
      try {
        setIsLoading(true)
        const data = await getClientList({ params: { isActive }, ...params })

        setClientList(formatClientSetupData(data?.data?.items))

        setTotalRecords(data?.data?.total)
        return data?.data
      } catch (e) {
        console.log('ERROR: ', e)
      } finally {
        setIsLoading(false)
      }
    },
    [isActive],
  )

  return { clientList, totalRecords, getClientListData, isLoading, setIsActive, isActive }
}
